import ApiUrl from "../../../configTools/api";
const User = JSON.parse(localStorage.getItem("user-info"));

const Get = (fdate,tdate,setValues) => {
    fetch(ApiUrl.LabAdminPrint_Salesrange+`?fdate=${fdate}&&tdate=${tdate}`,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        console.log(data.response);
        setValues(data.response);
    });
}

export default {Get};